import Store from 'store/store'
import { Component } from 'utils/jsx'
import { writable } from 'utils/state'
import contrast from 'utils/color-contrast'
import classnames from 'classnames'

import Seed from 'controllers/landscape/seed'
import Button from 'components/dom/Button'

const hash = colors => colors && colors.length
  ? colors.map(c => c.css).join(',')
  : ''

export default class Swatch extends Component {
  beforeRender () {
    this.handleClick = this.handleClick.bind(this)
    this.handleSeedClick = this.handleSeedClick.bind(this)
    this.update = this.update.bind(this)

    this.state = {
      hash: '',
      animatable: writable(true)
    }
  }

  template () {
    return (
      <div class='swatch' store-class-is-animatable={this.state.animatable}>
        {(window.ENV.features.buttons.seed || !window.ENV.production) && (
          <Button
            icon='code'
            class='swatch__btn'
            store-disabled={Store.landscape.isLoading}
            event-click={this.handleSeedClick}
          />
        )}
        <Button
          icon='magic'
          class='swatch__btn'
          store-disabled={Store.landscape.isLoading}
          event-click={this.handleClick}
        />
        <div class='swatch__colors' ref={this.ref('colors')} />
      </div>
    )
  }

  afterRender () {
    Store.landscape.colors.subscribe(this.update)
    this.update()
  }

  handleSeedClick () {
    const pSeed = Store.landscape.seed.get()
    Seed.value = window.prompt('seed', pSeed) || pSeed
  }

  handleClick () {
    Seed.update()
  }

  update () {
    const colors = Store.landscape.colors.get()

    this.state.animatable.set(hash(colors) !== this.state.hash)
    this.state.hash = hash(colors)

    this.refs.colors.innerHTML = ''
    colors.forEach((color, index) => {
      this.render((
        <Button
          class={classnames('swatch__color', { 'is-background': color.isBackground })}
          icon='paint-brush'
          style={`
            --background: ${color.css};
            --color: ${contrast(color.rgb)};
          `}
          store-disabled={Store.landscape.isLoading}
          event-click={this.handleColorClick(index).bind(this)}
        />
      ), this.refs.colors)
    })
  }

  handleColorClick (colorIndex) {
    return function (e) {
      e.stopPropagation()
      Seed.setBackground(colorIndex)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Swatch.js